import React from 'react'

const FileList = () => {
  return (
    <div>FileList</div>
  )
}

export default FileList